// extracted by extract-css-chunks-webpack-plugin
module.exports = {"business":"business_J+Fjf","nav":"nav_rYQn6"};